 "use strict";
 /**
  * trsHight Module
  *
  * Description
  */
 angular.module('trsLeftModule', []).directive('trsLeft', ['$window', '$parse', '$timeout', function ($window, $parse, $timeout) {

     return {
         restrict: 'EA',
         link: function (scope, iElement, iAttrs) {
             let line = $('.allChildLine');
             contentLeft();
             function contentLeft() {
                 $timeout(function () {
                     let left = $(iAttrs.element).width() - iElement.width();
                     iElement.css({
                         left: left
                     });
                     line.width($(iAttrs.element).width()-30);
                 });
             }
             $(iAttrs.element).scroll(function () {
                iElement.css({
                  left: ($(this).width() - iElement.width()) + $(this).scrollLeft()
                });
                line.width(($(this).width()-30)+$(this).scrollLeft());
             });
             scope.$on("getTrsLeft", function (event, data) {
                 contentLeft();
             });
             window.addEventListener("resize", resize);
             scope.$on("$destroy", function () {
                $(iAttrs.element).unbind('scroll')
                 window.removeEventListener("resize", resize);
             });
             /**
              * [resize description] 重置窗口
              * @return {[type]} [description]
              */
             function resize() {
                 contentLeft();
             }
         }
     };
 }]);